// Keep in sync with api/shared/listings.js CATEGORIES
export const CATEGORIES = [
  { id: "cleats", label: "Cleats" },
  { id: "jerseys", label: "Jerseys & Kits" },
  { id: "balls", label: "Balls" },
  { id: "shin-guards", label: "Shin Guards" },
  { id: "goalkeeper", label: "Goalkeeper" },
  { id: "bags", label: "Bags" },
  { id: "training", label: "Training Equipment" },
  { id: "apparel", label: "Apparel" },
  { id: "accessories", label: "Accessories" },
  { id: "other", label: "Other" },
];

export const CATEGORY_MAP = Object.fromEntries(CATEGORIES.map((c) => [c.id, c]));

export function categoryLabel(id) {
  return (CATEGORY_MAP[id] && CATEGORY_MAP[id].label) || "Other";
}

/* ── Sizes ──────────────────────────────────────────────────────────────────
   Deliberately PER CATEGORY: soccer sizing isn't one scale. Cleats run
   10C–13C / 1Y–6Y / adult 5–13, apparel runs YS–XL, balls are 3/4/5, and
   gloves are 5–11. One combined list would be wrong nearly everywhere.

   A shared vocabulary is also what makes saved alerts reliable — when both the
   listing and the alert pick from the same list, the old "M doesn't match
   Medium" problem disappears by construction rather than by cleverer matching.

   Categories absent from this map have no meaningful size and show no field.
   Every list ends with OTHER_SIZE, which reveals a free-text box — sizing is
   messy enough that a closed list would eventually be a dead end.           */
export const OTHER_SIZE = "__other__";

const YOUTH_SHOE = ["10C", "11C", "12C", "13C", "1Y", "2Y", "3Y", "4Y", "5Y", "6Y"];
const ADULT_SHOE = ["5", "6", "7", "8", "9", "10", "11", "12", "13", "14"];
const APPAREL = ["YXS", "YS", "YM", "YL", "YXL", "XS", "S", "M", "L", "XL", "XXL"];

export const SIZES_BY_CATEGORY = {
  cleats: [...YOUTH_SHOE, ...ADULT_SHOE],
  jerseys: APPAREL,
  apparel: APPAREL,
  balls: ["3", "4", "5"],
  "shin-guards": ["XS", "S", "M", "L", "XL"],
  goalkeeper: ["5", "6", "7", "8", "9", "10", "11"],
  bags: ["Small", "Medium", "Large"],
  // training, accessories and other have no standard sizing — no field shown.
};

// The options for a category, or [] when the category has no sizing.
export function sizesFor(categoryId) {
  return SIZES_BY_CATEGORY[categoryId] || [];
}

export function categoryHasSizes(categoryId) {
  return sizesFor(categoryId).length > 0;
}

export const CONDITIONS = [
  { id: "new", label: "New" },
  { id: "like-new", label: "Like New" },
  { id: "good", label: "Good" },
  { id: "fair", label: "Fair" },
];
export const CONDITION_MAP = Object.fromEntries(CONDITIONS.map((c) => [c.id, c]));
export function conditionLabel(id) {
  return (CONDITION_MAP[id] && CONDITION_MAP[id].label) || "Good";
}
